import Dashboard from '../views/Dashboard'
import Projects from '../views/Projects'
import Reports from '../views/Reports'
import Team from '../views/Team'
import Home from '../views/Home'
import Clients from '../views/Clients'
import Favorites from '../views/Favorites'
import Drafts from '../views/Drafts'
import Archive from '../views/Archive'
import Files from '../views/Files'
import {
  SvgIconProps,
  DashboardIcon,
  ProjectsIcon,
  TeamIcon,
  ReportsIcon,
  HomeIcon,
  FavoritesIcon,
  DraftsIcon,
  ArchiveIcon,
} from '../components/Svgs'
import FileComponent from '../components/Architecture/FileComponent'
import { UserRoleNames } from '../models/AccessControl'

export interface MenuItemProps {
  label: string
  route: string
  component: () => JSX.Element
  icon?: React.FC<SvgIconProps>
  exact?: boolean
  nestedRoutes?: MenuItemProps[]
  roles?: UserRoleNames[]
}

export const commonMenuItems: MenuItemProps[] = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    component: Dashboard,
    icon: DashboardIcon,
  },
  {
    label: 'Projects & Requests',
    route: '/projects',
    component: Projects,
    icon: ProjectsIcon,
    nestedRoutes: [
      {
        label: 'Project File',
        route: '/projects/:fileId',
        component: FileComponent,
      },
    ],
  },
  {
    label: 'Team',
    route: '/team',
    component: Team,
    icon: TeamIcon,
  },
  {
    label: 'Reports',
    route: '/reports',
    component: Reports,
    icon: ReportsIcon,
  },
  {
    label: 'Home',
    route: '/home',
    component: Home,
    icon: HomeIcon,
  },
  {
    label: 'Clients',
    route: '/clients',
    component: Clients,
    icon: ProjectsIcon,
    nestedRoutes: [
      {
        label: 'Client Projects',
        route: '/clients/:clientId/projects',
        component: Projects,
      },
      {
        label: 'Client Project Files',
        route: '/clients/:clientId/projects/:projectId/files',
        component: Files,
      },
    ],
  },
  {
    label: 'Projects',
    route: '/projects',
    component: Projects,
    icon: ProjectsIcon,
    nestedRoutes: [
      {
        label: 'Project Files',
        route: '/projects/:projectId/files',
        component: Files,
      },
      {
        label: 'Project File',
        route: '/projects/:projectId/files/:fileId',
        component: FileComponent,
      },
      {
        label: 'Upload Files',
        route: '/projects/:projectId/uploadFiles',
        component: FileComponent,
      },
    ],
  },
  {
    label: 'Favorites',
    route: '/favorites',
    component: Favorites,
    icon: FavoritesIcon,
  },
  {
    label: 'Drafts',
    route: '/drafts',
    component: Drafts,
    icon: DraftsIcon,
  },
  {
    label: 'Archive',
    route: '/archive',
    component: Archive,
    icon: ArchiveIcon,
  },
]
